<template>
  <div class="d-flex align-items-center gap-3 mb-3">
    <i :class="iconClass" v-if="icon != 'none'"></i>
    <div>
      <span v-if="!props.isHtml" v-text="content"/>
      <span v-if="props.isHtml" v-html="content"/>
    </div>
  </div>
</template>

<script setup lang="ts">
import {getCurrentInstance, onMounted, ref} from "vue";
import {modalDefinedEmits, type ToolbarReference, useModalBuilder} from "@helpers/modal-building-helper";
import type {messageBoxButtons, messageBoxIcon} from "@components/dialogs/message-box";
import {messageBoxResult} from "@components/dialogs/message-box";
import {DxButton} from "devextreme-vue/button";

const iconClass = ref("");


onMounted(() => {
  const modal = useModalBuilder();
  modal.setContext(getCurrentInstance()!)

  selectIcon();
  configureButtons(modal);
});

function configureButtons(modal: ReturnType<typeof useModalBuilder>) {
  let okButton : ToolbarReference<DxButton>;
  let cancelButton: ToolbarReference<DxButton>;
  let yesButton: ToolbarReference<DxButton>
  let noButton: ToolbarReference<DxButton>;
  
  switch (props.buttons) {
    case "ok":
      modal.standardButtons.addOk().update(w => w.onClick = () => modal.close(messageBoxResult.ok));
      break;
    case "okCancel":
      ({okButton, cancelButton} = modal.standardButtons.addOkCancel());
      okButton.update(w => w.onClick = () => modal.close(messageBoxResult.ok));
      cancelButton.update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
      break;
    case "yesNo":
      ({yesButton, noButton} = modal.standardButtons.addYesNo());
      yesButton.update(w => w.onClick = () => modal.close(messageBoxResult.yes));
      noButton.update(w => w.onClick = () => modal.close(messageBoxResult.no));
      break;
    case "yesNoCancel":
      ({yesButton, noButton, cancelButton} = modal.standardButtons.addYesNoCancel());
      yesButton.update(w => w.onClick = () => modal.close(messageBoxResult.yes));
      noButton.update(w => w.onClick = () => modal.close(messageBoxResult.no));
      cancelButton.update(w => w.onClick = () => modal.close(messageBoxResult.cancel));
      break;
  }
}

function selectIcon() {
  switch (props.icon) {
    case "info":
      iconClass.value = "messagebox-icon-info";
      break;
    case "warning":
      iconClass.value = "messagebox-icon-warning";
      break;
    case "error":
      iconClass.value = "messagebox-icon-error";
      break;
    case "success":
      iconClass.value = "messagebox-icon-success";
      break;
  }
}

defineEmits([...modalDefinedEmits])
const props = withDefaults(defineProps<{
      buttons: messageBoxButtons,
      icon: messageBoxIcon,
      content: string,
      isHtml?: boolean
    }>(),
    {
      isHtml: false
    }
);
</script>

<style scoped>

</style>

